import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { IonApp, IonRouterOutlet, IonSplitPane, IonAlert } from '@ionic/vue';
import "@fortawesome/fontawesome-free/css/solid.css";
import "@fortawesome/fontawesome-free/css/fontawesome.css";
import MainMenu from './components/MainMenu/MainMenu.vue';
import { useRoute, useRouter } from 'vue-router';
import { reactive, ref, watch, onMounted, onUnmounted } from 'vue';
import { check_for_reset_user, useTouchpointsHTTP } from './use/useTouchpointsHTTP';
import getDevice from './use/useGetDeviceInfo';
import { appStatus } from "./use/useAppStatus";

import { usePushNotificationReceiver } from './use/usePushNotificationReceiver';

import { useRequestQueue } from '@/use/useRequestQueue';

/* Request queue */
const multipleSessionTabsMessage = "You’ve already got the diary opened in another tab. Please close the other tab to continue.";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

/*
  imports
*/
onMounted(() => {
  appStatus.requestQueue = useRequestQueue();
  appStatus.requestQueue.start();
});

onUnmounted(() => {
  appStatus.requestQueue.stop();
});



localStorage.openpages = Date.now();

window.addEventListener('storage', function (e) {
    if(e.key == "openpages") {
        // Listen if anybody else is opening the same page!
        localStorage.page_available = Date.now();
    }
    if(e.key == "page_available") {
      console.log("One more page already open");
      appStatus.showMultipleSessionTabsError = true;
    }
}, false);

if(localStorage.getItem("session_id") === null || localStorage.getItem("session_id") === undefined) {
  if(localStorage.getItem("userId") && localStorage.getItem("userId")!.trim() !== "") {
    localStorage.setItem("session_id", Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));
  }
}

if(appStatus.showMultipleSessionTabsError) {
  console.log("Show tabs alert")
}

const {updateDiaryLastAccessTime} = useTouchpointsHTTP();

const blocked_urls = ['/onboarding', '/termsandconditions', '/privacy', '/training', '/login', '/welcome', '/question', '/contactsupport', '/notifications', '/sleeptask' , '/adhoc'];

const route = useRoute();
// eslint-disable-next-line
const router = useRouter();
const usePushNotification = usePushNotificationReceiver();

const initial_menu_state = blocked_urls.filter((path) => path === route.path)[0] === undefined ? true : false;

const state = reactive({
  path: route.path,
  menu_allowed: initial_menu_state
});


if(localStorage.getItem("username")) {
  const deviceInfo = getDevice(navigator.userAgent, localStorage.getItem("username")!);
  useTouchpointsHTTP().saveDevice(deviceInfo!);
}

window.addEventListener('popstate', (e) => {
  e.preventDefault();
  setTimeout(() => {
    window.location.reload();
  }, 200);
});

function logOut() {
  window.localStorage.removeItem("userId")
  window.localStorage.removeItem("touchPointsLastLogin")
  window.localStorage.removeItem("username")
  window.localStorage.removeItem("touchPointsAuth")
  window.localStorage.removeItem("diaryStartDate")
  window.localStorage.removeItem("privacyAgree")
  window.localStorage.removeItem("trainingAgree")
  window.localStorage.removeItem("sleepTaskAgree")
  window.localStorage.removeItem("termAgree")
  window.localStorage.removeItem("dummyTimeslot")
  window.localStorage.removeItem("diaryId")
  window.localStorage.removeItem("session_id");
  setTimeout(() => {
    location.reload();
    router.push({name: 'login'});
  }, 100); 
}

const isOpen = ref(false);
const setOpen = (state: boolean) => {
  isOpen.value = state;
};

const alertButtons = [{
          text: 'Logout',
          handler: () => {
            logOut();
            localStorage.setItem("checked_for_reset", "true");
          },
        },
      ];

const multipleSessionButtons = [
  {
    text: 'Understood',
    handler: () => {
      window.location.reload()
    },
  },
]

if(localStorage.getItem('username')) {

  useTouchpointsHTTP().getDiary(localStorage.getItem("username")!)
  .then((response: any) => {
    const currentDate = new Date();
    const diaryDate = new Date(response.data.first_day_time);
    // update diary ID
    localStorage.setItem("diaryId", `${response.data.id}`)
    //console.log(diaryDate)
    if (currentDate >= diaryDate) {
      updateDiaryLastAccessTime(localStorage.getItem('username')!);
    } else {
      router.push("/onboarding")
    }
  })

  check_for_reset_user(localStorage.getItem("username")!)
  .then((response) => {
    const check_for_reset = response.check_for_reset;
    if(check_for_reset) {
      if(localStorage.getItem("checked_for_reset") !== "true" && localStorage.getItem("checked_for_reset") !== "false") {
        localStorage.setItem("checked_for_reset", "false");
        setOpen(true);
      }
      if(localStorage.getItem("checked_for_reset") === "false") {
        setOpen(true);
      }
      if(localStorage.getItem("checked_for_reset") === "true") {
        useTouchpointsHTTP().getDiary(localStorage.getItem("username")!)
        .then((response: any) => {
          //console.log(response.data)
          const localDiaryId = localStorage.getItem("diaryId");
          const currentDiaryId = response.data.id;

          if(Number(localDiaryId) !== currentDiaryId) {
            localStorage.setItem("checked_for_reset", "false");
            setOpen(true);
          }
        })
        //console.log("check diary")
      }
    }
  })
}
/* //[debug commnet out reopen when live]
if ('serviceWorker' in navigator) {
    console.log('Service Worker is supported in this browser.');
    // You can register your Service Worker here
} else {
  alert("Service Worker is not supported in this browser.");
  window.location.replace("error.html");
}
*/

// Add the serviceWorker message event listener
navigator.serviceWorker.addEventListener('message', usePushNotification.onHandleMessageEvent);

watch(route, (newRoute) => {
  state.path = newRoute.path;
  const found_url = blocked_urls.filter((path) => path === newRoute.path);
  if(found_url[0] ) {
    state.menu_allowed = false;
  }
  else {
    state.menu_allowed = true
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonSplitPane), { "content-id": "main-content" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRouterOutlet), { id: "main-content" })
        ]),
        _: 1
      }),
      (state.menu_allowed === true)
        ? (_openBlock(), _createBlock(MainMenu, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonAlert), {
        isOpen: isOpen.value,
        header: "TouchPoints",
        message: "Your diary has been reset, please relogin to continue",
        backdropDismiss: "false",
        buttons: alertButtons,
        onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (setOpen(false)))
      }, null, 8, ["isOpen"]),
      _createVNode(_unref(IonAlert), {
        isOpen: _unref(appStatus).showMultipleSessionTabsError,
        header: "TouchPoints",
        message: multipleSessionTabsMessage,
        backdropDismiss: "false",
        buttons: multipleSessionButtons,
        onDidDismiss: _cache[1] || (_cache[1] = ($event: any) => (_unref(appStatus).showMultipleSessionTabsError = false))
      }, null, 8, ["isOpen"])
    ]),
    _: 1
  }))
}
}

})